const NS = 'http://www.w3.org/2000/svg';
const CX = 120, CY = 125, R = 100;
const VERDE = '#1f9d5c', AMBAR = '#d99a16', VERMELHO = '#e0483b', CINZA = '#e6e9ee', MUTED = '#6b7585';

function n(tag, attrs, filhos) {
  const e = document.createElementNS(NS, tag);
  for (const k in attrs) e.setAttribute(k, attrs[k]);
  if (filhos != null) [].concat(filhos).forEach((f) => e.append(f));
  return e;
}
function polar(p, r = R) {
  const ang = Math.PI * (1 - Math.max(0, Math.min(100, p)) / 100);
  return { x: CX + r * Math.cos(ang), y: CY - r * Math.sin(ang) };
}
function arco(p1, p2, r) {
  const a = polar(p1, r), b = polar(p2, r);
  return `M ${a.x.toFixed(1)} ${a.y.toFixed(1)} A ${r} ${r} 0 0 1 ${b.x.toFixed(1)} ${b.y.toFixed(1)}`;
}
function zona(svg, p1, p2, cor) {
  if (p2 - p1 > 0.5) svg.append(n('path', { d: arco(p1, p2, R), fill: 'none', stroke: cor, 'stroke-width': 16, opacity: 0.28 }));
}
function corDoValor(valor, meta, modoBom, margem) {
  if (modoBom === 'baixo') {
    if (valor <= meta) return VERDE;
    if (valor <= meta + margem) return AMBAR;
    return VERMELHO;
  }
  if (valor >= meta) return VERDE;
  if (valor >= meta - margem) return AMBAR;
  return VERMELHO;
}

/**
 * Velocimetro semicircular com faixas verde/amarelo/vermelho frente a meta.
 * @param {{valor:number, meta:number, modoBom?:'alto'|'baixo', margem?:number, semDados?:boolean, neutro?:boolean}} o
 */
export function velocimetro(o) {
  const modoBom = o.modoBom || 'alto';
  const margem = o.margem ?? 10;
  const meta = Math.max(0, Math.min(100, o.meta || 0));
  const cor = (o.semDados || o.neutro) ? MUTED : corDoValor(o.valor, meta, modoBom, margem);
  const svg = n('svg', { viewBox: '0 0 240 172', class: 'gauge', role: 'img' });

  // trilho de fundo
  svg.append(n('path', { d: arco(0, 100, R), fill: 'none', stroke: CINZA, 'stroke-width': 16, 'stroke-linecap': 'round' }));

  if (!o.semDados && o.neutro) {
    svg.append(n('path', { d: arco(0, Math.max(1, o.valor), R), fill: 'none', stroke: MUTED, 'stroke-width': 16, opacity: 0.3 }));
  } else if (!o.semDados) {
    if (modoBom === 'baixo') {
      zona(svg, 0, meta, VERDE);
      zona(svg, meta, Math.min(100, meta + margem), AMBAR);
      zona(svg, Math.min(100, meta + margem), 100, VERMELHO);
    } else {
      zona(svg, 0, Math.max(0, meta - margem), VERMELHO);
      zona(svg, Math.max(0, meta - margem), meta, AMBAR);
      zona(svg, meta, 100, VERDE);
    }
    // tick da meta
    const mi = polar(meta, R - 11), mo = polar(meta, R + 11);
    svg.append(n('line', { x1: mi.x.toFixed(1), y1: mi.y.toFixed(1), x2: mo.x.toFixed(1), y2: mo.y.toFixed(1), stroke: MUTED, 'stroke-width': 2 }));
  }

  // ponteiro
  if (!o.semDados) {
    const pt = polar(o.valor, R - 24);
    svg.append(n('line', { x1: CX, y1: CY, x2: pt.x.toFixed(1), y2: pt.y.toFixed(1), stroke: cor, 'stroke-width': 4, 'stroke-linecap': 'round' }));
  }
  svg.append(n('circle', { cx: CX, cy: CY, r: 7, fill: cor }));
  // numero central
  svg.append(n('text', { x: CX, y: 165, 'text-anchor': 'middle', class: 'gauge__num', fill: cor },
    [document.createTextNode(o.semDados ? '—' : Math.round(o.valor) + '%')]));

  return svg;
}
